<template>
  <div class="fa">
    <el-container>
      <el-aside :class="bors" :width="isCollapse ? '64px' : '200px'">
        <div
          :class="unclick ? 'toggle-button button-unclick' : 'toggle-button'"
          @click="toggleCollapse"
        >
          |||
        </div>
        <el-menu
          background-color="#fff"
          text-color="#808080"
          active-text-color="#409EFF"
          unique-opened
          :default-active="activePath"
          :collapse="isCollapse"
          :collapse-transition="false"
        >
          <el-submenu
            v-for="item in menu_list"
            :v-show="item.show"
            :key="item.index"
            :index="item.index"
          >
            <template slot="title">
              <div>
                <i :class="item.icon_class"></i>
                <span class="one">{{ item.total_name }}</span>
              </div>
            </template>
            <el-menu-item
              v-for="(citem, index) in item.children"
              :key="index"
              :index="citem.index"
              @click="saveNavState(citem.index)"
            >
              <template slot="title">
                <i :class="citem.icon_class"></i>
                <span>{{ citem.name }}</span>
              </template>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
      <!-- 头部区域 -->

      <el-container>
        <el-header :style="'height:' + header_height + 'px;'">
          <div>
            <!-- @click="goHome" -->
            <div>
              <img
                class="el-header-img"
                src="@/assets/pic/yvzhou.png"
                alt=""
              />
            </div>
            <!-- :style="width:" -->
            <div style="display:flex">
              <el-dropdown @command="setMchInfo">
                <span class="el-dropdown-link">
                  <b
                    style="width:300px; font-size:24px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap"
                  >
                     <b style="color:#409eff">{{ mch_name }}</b>  后台<i
                      class="el-icon-arrow-down el-icon--right"
                    ></i
                  ></b>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="item in mch_list"
                    :key="item.mch_id"
                    :command="item.mch_id"
                    >{{ item.mch_name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>

          <el-button :size="btn_size" type="danger" plain @click="lohout"
            >退出</el-button
          >
        </el-header>
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import { GetAuthorizeMerchant } from "@/api/baseinfo";
export default {
  inject: ["reload"],
  data() {
    return {
      mch_list: [],
      header_height: "60",
      isCollapse: true,
      activePath: "",
      account: "",
      mch_name: "",
      showBox: false,
      merchant_id: "",
      merchants: [],
      bors: "",
      screen_w: window.screen.availWidth,
      body_w: document.body.clientWidth,
      subtract: "",
      // 控制侧边栏隐藏显示按钮是否可点击
      unclick: true,
      resolution: "",
      title_width: "",
      btn_size: "medium",
      menu_list: [
        {
          index: "1",
          total_name: "基本信息",
          icon_class: "iconfont icon-style-item icon-wodeshangpin",
          children: [
            {
              index: "/classInfo",
              icon_class: "el-icon-menu",
              name: "商品类别"
            },
            {
              index: "/goodsInfo",
              icon_class: "el-icon-s-goods",
              name: "商品信息"
            }
          ]
        },
        {
          index: "2",
          icon_class: "el-icon-s-home",
          total_name: "仓库管理",
          children: [
            {
              index: "/reportware",
              icon_class: "el-icon-plus",
              name: "生成单据"
            }
          ]
        },
        {
          index: "3",
          icon_class: "el-icon-s-check",
          total_name: "电子合约",
          children: [
            {
              index: "/createContract",
              icon_class: "el-icon-edit",
              name: "电子合约"
            },
            {
              index: "/collection",
              icon_class: "el-icon-tickets",
              name: "收费项管理"
            }
          ]
        }
        /*  {
          index: 4,
          icon_class: "el-icon-s-order",
          total_name: "财务管理",
          children: [
            {
              index: "/business",
              icon_class: "el-icon-money",
              name: "账单管理"
            }
          ]
        } */
      ]
    };
  },
  watch: {
    body_w: {
      handler(neww, oldw) {
        this.subtract = this.screen_w - neww;
        if (this.subtract > 200) {
          this.isCollapse = true;
          this.unclick = true;
        } else if (this.resolution >= 1280 * 1024 && this.subtract <= 200) {
          this.isCollapse = false;
          this.unclick = false;
        }
        if (this.resolution <= 1280 * 1024) {
          this.isCollapse = true;
          this.unclick = true;
        }
      },
      immediate: true
    }
  },
  async created() {
    this.activePath = localStorage.getItem("activePath");
    this.resolution = window.screen.height * window.screen.width;
    if (this.resolution <= 1280 * 1024) {
      // 折叠左侧导航条
      this.isCollapse = true;
      // 取消导航条上边按钮的点击功能
      this.unclick = true;
    }
  },
  async mounted() {
    this.mch_name = localStorage.getItem("mch_name");
    this.body_w = document.documentElement.clientWidth;
    window.onresize = () => {
      //屏幕尺寸变化就重新赋值
      return (() => {
        this.body_w = document.body.clientWidth;
      })();
    };
    this.subtract = this.screen_w - this.body_w;
    if (this.subtract > 200) {
      this.isCollapse = true;
      this.unclick = true;
    } else {
      this.isCollapse = false;
      this.unclick = false;
    }
    if (this.resolution <= 1280 * 1024) {
      this.isCollapse = true;
      this.unclick = true;
      this.header_height = "50";
      this.btn_size = "small";
    }
    if (this.resolution <= 800 * 600) {
      this.header_height = "40";
      this.btn_size = "mini";
    }
    try {
      const res = await GetAuthorizeMerchant();
      console.log("获取店铺列表", res);
      if (
        res.data.return_code == "SUCCESS" &&
        res.data.result_code == "SUCCESS" &&
        res.data.resp_data
      ) {
        this.mch_list = res.data.resp_data;
        if (this.mch_list.length >= 1) {
          window.localStorage.setItem("mch_id", this.mch_list[0].mch_id);
          window.localStorage.setItem("mch_name", this.mch_list[0].mch_name);
          this.mch_name = this.mch_list[0].mch_name;
        }
      }
    } catch (e) {
      console.log(e);
    }
  },
  updated() {},
  beforeUpdate() {},
  methods: {
    lohout() {
      localStorage.clear();
      this.$router.push("/login");
    },
    // 点击按钮让菜单折叠和展开
    toggleCollapse() {
      this.isCollapse = !this.isCollapse;
    },
    togCollapse() {
      this.isCollapse = true;
    },
    // 刷新之后也可以保持高亮状态
    saveNavState(activePath) {
      localStorage.setItem("activePath", activePath);
      this.activePath = activePath;
    },
    goHome() {
      localStorage.removeItem("activePath");
      //换一个其他的路径吧
      // this.$router.push("welcome");
      this.reload();
    },
    setMchInfo(key) {
      this.mch_list.forEach((item, i, arr) => {
        if (item.mch_id == key) {
          window.localStorage.setItem("mch_id", key);
          window.localStorage.setItem("mch_name", item.mch_name);
          this.mch_name = item.mch_name;
        }
      });
      this.reload();
    }
  }
};
</script>
<style scoped>
.fa {
  position: relative;
  height: 100%;
  width: 100%;
  background-color: #fff;
  /* background: url(../assets/zcm.jpg); */
  background-position: center center;
  background-attachment: fixed;
  background-size: 100% auto;
  padding: 0;
  /* background-color: rgba(5, 129, 26, 0.432); */
}
.el-header {
  display: flex;
  justify-content: space-between;
  background-color: #fff;
  align-items: center;
  color: rgb(115, 115, 115);
  font-size: 24px;
  border-left: 1px solid rgb(243, 243, 243);
}
.el-header div {
  display: flex;
  align-items: center;
}
.el-header-img {
  cursor: pointer;
  height: 60px;
  margin-right: 15px;
}
.el-aside {
  background-color: #fff;
  border-left: 1px solid rgb(243, 243, 243);
}
.el-aside::-webkit-scrollbar {
  display: none;
}
.el-main {
  height: 100%;
  background-color: #eff4ff;
  padding: 0;
}
.el-container {
  height: 100%;
}
.el-menu {
  border-right: none;
}
.toggle-button {
  background-color: rgb(243, 243, 243);
  font-size: 10px;
  line-height: 24px;
  color: black;
  text-align: center;
  letter-spacing: 0.2em;
  cursor: pointer;
}
.el-submenu {
  background-color: #fff;
  font-size: 24px;
  /* border-bottom: 1px solid rgb(151, 150, 150); */
  /* color: #dddddd; */
}
.one {
  font-size: 16px;
}
span {
  font-weight: 700;
}

.el-icon-s-order,
.el-icon-s-check,
.el-icon-s-home {
  font-size: 24px !important;
  color: #409eff;
}
.icon-style-item {
  display: inline-block;
  color: #409eff;
  vertical-align: middle;
  margin-right: 5px;
  width: 24px;
  text-align: center;
  font-size: 18px;
}

.el-menu-item {
  background-color: rgb(255, 255, 255) !important;
}
.button-unclick {
  pointer-events: none;
}
</style>
